import React from 'react';

/**
 * Running-person icon matching the `fa-running` icon the old RoR application
 * used in the navbar next to the batch-optimize / scheduled-runs count.
 * Path data from FontAwesome Free v5 (CC BY 4.0 License — https://fontawesome.com/license/free).
 */
export const RunningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 416 512"
    fill="currentColor"
    width="16"
    height="16"
    aria-hidden="true"
    {...props}
  >
    <path d="M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.5-35.46-43.75-62.71-50l-40.61-9.3-17.17-41.41C186.6 54.61 171.47 48 155.75 48c-6.33 0-12.72 1.08-18.91 3.29l-82.2 29.55c-16.65 5.99-30.76 17.13-39.36 31.04-13.07 21.21-6.41 49.11 14.91 61.47 18.88 10.9 42.42 3.35 53.3-14.42l14.52-23.47 43.39-15.59L71.31 225.55a63.995 63.995 0 0 0 30.36 77.76l105.03 52.51-22.27 89.08c-4.28 17.14 6.14 34.51 23.28 38.79 2.61.66 5.22.95 7.78.95 14.33 0 27.37-9.7 31.02-24.22l26.49-105.97c5.57-22.31-4.49-45.52-24.46-56.49l-43.32-23.68 28.56-113.94 16.73 34.2c8.39 17.14 25.98 28.07 45.04 28.07H384c17.67 0 32-14.33 32-32s-14.33-32.03-32-32.03z" />
  </svg>
);
